import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

interface DocumentTitleProps {
  title: string;
  onChange: (title: string) => void;
}

export function DocumentTitle({ title, onChange }: DocumentTitleProps) {
  const [value, setValue] = useState(title);

  useEffect(() => {
    setValue(title);
  }, [title]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    // The page's save coordinator coalesces writes. Report every title edit
    // immediately so title and body can be checkpointed as one revision.
    onChange(e.target.value);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      className="text-xl font-medium border-none bg-transparent focus:outline-none focus:ring-0 px-0 py-2"
      placeholder="Untitled Document"
    />
  );
}
